module.exports = __webpack_public_path__ + "img/webpack.4b42c339.png";